import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import axios from '../../_utils/axios';
import Modal from '../_common/Modal/Modal';
import PolarisIcon from '../_common/PolarisIcon';

type ProfileBuilderPreviewTemplateProps = {
  disabled: boolean;
  template: string | TrustedHTML;
};

const ProfileBuilderPreviewTemplate = ({ disabled, template }: ProfileBuilderPreviewTemplateProps) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [html, setHtml] = useState(null);

  useEffect(() => {
    if (template && modalOpen) {
      axios.get(`/core/email_templates/${template}/`).then((res) => setHtml(res.data?.data));
    }
  }, [template, modalOpen]);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  return (
    <div>
      <Button disabled={disabled} onClick={toggleModal} startIcon={<PolarisIcon icon="preview" />} sx={{ marginTop: 1 }}>
        Preview Template
      </Button>
      <Modal open={modalOpen} onClose={toggleModal} title="Email Template Preview" icon={<PolarisIcon icon="preview" />}>
        <div dangerouslySetInnerHTML={{ __html: html || '' }} />
      </Modal>
    </div>
  );
};

export default ProfileBuilderPreviewTemplate;
